import { render, staticRenderFns } from "./SelfMediaInfo.vue?vue&type=template&id=7da053ac&scoped=true"
import script from "./SelfMediaInfo.vue?vue&type=script&lang=js"
export * from "./SelfMediaInfo.vue?vue&type=script&lang=js"
import style0 from "./SelfMediaInfo.vue?vue&type=style&index=0&id=7da053ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da053ac",
  null
  
)

export default component.exports